/**
 * 測量座標点 (SurveyPoint) の統合インデックス。
 * 複合キー (${pointNumber}-${pointName}) → 点番号 (pointNumber) → 点名 (pointName) の順で
 * 一貫したフォールバック解決を提供し、O(1) での検索と追加を実現します。
 */
export class SurveyPointIndex {
    _byComposite = new Map();
    _byNumber = new Map();
    _byName = new Map();
    _points = [];
    _pointSet = new Set();
    constructor(points = []) {
        for (const pt of points) {
            this.add(pt);
        }
    }
    /**
     * インデックスに測量座標点を追加します。
     */
    add(point) {
        const num = point.pointNumber;
        const name = point.pointName;
        this._byComposite.set(`${num}-${name}`, point);
        if (num !== undefined) {
            this._byNumber.set(num, point);
        }
        if (name && name.trim() !== "") {
            this._byName.set(name, point);
        }
        if (!this._pointSet.has(point)) {
            this._pointSet.add(point);
            this._points.push(point);
        }
    }
    /**
     * 点番号および点名から SurveyPoint を検索します。
     * 解決優先度:
     * 1. 複合キー (${pointNumber}-${pointName})
     * 2. 点番号 (pointNumber)
     * 3. 点名 (pointName)
     */
    lookup(pointNumber, pointName) {
        if (pointNumber !== undefined &&
            pointName !== undefined &&
            pointName !== "") {
            const composite = this._byComposite.get(`${pointNumber}-${pointName}`);
            if (composite)
                return composite;
        }
        if (pointNumber !== undefined) {
            const byNum = this._byNumber.get(pointNumber);
            if (byNum)
                return byNum;
        }
        if (pointName && pointName !== "") {
            const byName = this._byName.get(pointName);
            if (byName)
                return byName;
        }
        return undefined;
    }
    /**
     * 全ての SurveyPoint 一覧を取得します。
     */
    get points() {
        return this._points;
    }
    /**
     * 後方互換性のある共有座標プール Map を生成・返却します。
     */
    toPoolMap() {
        const map = new Map();
        for (const pt of this._points) {
            map.set(`${pt.pointNumber}-${pt.pointName}`, pt);
            if (pt.pointNumber !== undefined) {
                map.set(String(pt.pointNumber), pt);
            }
            if (pt.pointName) {
                map.set(pt.pointName, pt);
            }
        }
        return map;
    }
}
//# sourceMappingURL=survey-point-index.js.map